/* eslint-disable import/prefer-default-export */
import cpcCardConfig from '../../Data/Maps/cpcCardConfig';
import {
  getEnvConfigForFormId,
  getMappedComponents,
} from '../__helpers__/component.helpers';

export const shouldShowCpcCardOnThisPage = (
  formId,
  components,
  currentPage
) => {
  const envCpcCardConfigForFormId = getEnvConfigForFormId({
    config: cpcCardConfig,
    formId,
  });

  if (!envCpcCardConfigForFormId) {
    return false;
  }

  const mappedComponents = getMappedComponents({
    config: envCpcCardConfigForFormId,
    components,
  });

  const highestMappedPage = Object.values(mappedComponents).reduce(
    (acc, component) => {
      return Math.max(acc, component.component.page);
    },
    0
  );

  const cpcCardPageNumber = highestMappedPage + 1;

  // Do not show the CPC card on pages where it isn't applicable
  if (cpcCardPageNumber !== currentPage) {
    return false;
  }

  return true;
};
